<script lang="ts">
  import { surveyStatus } from '../stores'
  import { getAnswersToBeDrawn, drawPortrait } from '../utils/portrait'

  let portraitContainer: HTMLDivElement
  export let width: number = 75

  export let answerList = null

  let stage
  export const createDataURL = () => stage.toDataURL()

  $: {
    if (!portraitContainer) {
      break $
    }

    const answersToBeDrawn = answerList === null ? getAnswersToBeDrawn($surveyStatus) : answerList
    stage = drawPortrait(portraitContainer, answersToBeDrawn, { width })
  }
</script>

<div bind:this={portraitContainer} class="canvasContainer" />

<style>
  .canvasContainer {
    display: inline-block;
  }
</style>
